import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'attendence';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const attendenceActions = { ...slice.actions, ...extraActions };
export const attendenceReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        monthlyComments: monthlyComments(),
        getMonthlyComments:getMonthlyComments(),
    };    

    function monthlyComments() {
        return createAsyncThunk(
            `${name}/attendence`,
            async ({r_comments, l_comments, s_comments, w_comments, g_comments, v_comments, o_comments, date, student_id, teacher_id}) => await fetchWrapper.post(`${baseUrl}/attendence/grades/comments`, { r_comments, l_comments, s_comments, w_comments, g_comments, v_comments, o_comments, date, student_id,teacher_id })
        );
    }

    function getMonthlyComments() {
        return createAsyncThunk(
            `${name}/attendence`,
            async ({date, student_id, teacher_id}) => await fetchWrapper.get(`${baseUrl}/attendence/monthlycomments/`+teacher_id+'/'+student_id+'?date='+date)
        );
    }


}

function createExtraReducers() {
    return {
        ...monthlyComments(),
        ...getMonthlyComments(),
    };

    function monthlyComments() {
        var { pending, fulfilled, rejected } = extraActions.monthlyComments;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const comments = action.payload;
              //console.log(user,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(user));
                state.comments = comments;
                console.log(comments,'sds');
                // toast.success('Check your email to verify the account..', {
                //     position: "top-right",
                //     autoClose: 5000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "light",
                //     });
                // get return url from location state or default to home page
                // const { from } = { from: { pathname: '/verify-email' } };
                // history.navigate(from);
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er anj');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function getMonthlyComments() {
        var { pending, fulfilled, rejected } = extraActions.getMonthlyComments;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const comments = action.payload;
              //console.log(user,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(user));
                state.comments = comments;
                console.log(comments,'sds');
                // toast.success('Check your email to verify the account..', {
                //     position: "top-right",
                //     autoClose: 5000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "light",
                //     });
                // get return url from location state or default to home page
                // const { from } = { from: { pathname: '/verify-email' } };
                // history.navigate(from);
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er anj');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }


}
